import { ATYPICAL_SURCHARGE_TYPE_OPTIONS } from "../constants"

export const getAtypicalSurchargeTypeLabel = (type: string): string => {
  const option = ATYPICAL_SURCHARGE_TYPE_OPTIONS.find((opt) => opt.value === type)
  return option?.label || type
}
